var map = {
	"./cover-with-bg-desktop.webp": 104,
	"./cover-with-bg-mobile.webp": 105,
	"./drdong/drdong.webp": 106,
	"./lastframe/lastframe.webp": 107,
	"./logo/logo-inverted.webp": 56,
	"./logo/logo.webp": 108,
	"./main-characters-end/main-characters-end.webp": 109,
	"./main-characters-padded/main-characters-padded.webp": 110,
	"./thumbnails/Dynamicbehaviour.webp": 111,
	"./thumbnails/SphereEmbedding.webp": 112,
	"./thumbnails/SphereSubspaces.webp": 113,
	"./thumbnails/TopologicalRelations.webp": 114,
	"./thumbnails/Vector-representation.webp": 115,
	"./wife-and-cat/wife-and-cat.webp": 116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;